import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_7156_71587)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V4C0 4.59067 0.258 5.12267 0.666667 5.48933V12.6667C0.666667 14.5047 2.162 16 4 16H12C13.838 16 15.3333 14.5047 15.3333 12.6667V5.48933C15.742 5.12267 16 4.59133 16 4V3.33333C16 1.49533 14.5047 0 12.6667 0ZM1.33333 3.33333C1.33333 2.23067 2.23067 1.33333 3.33333 1.33333H12.6667C13.7693 1.33333 14.6667 2.23067 14.6667 3.33333V4C14.6667 4.368 14.368 4.66667 14 4.66667H2C1.63267 4.66667 1.33333 4.368 1.33333 4V3.33333ZM14 12.6667C14 13.7693 13.1027 14.6667 12 14.6667H4C2.89733 14.6667 2 13.7693 2 12.6667V6H14V12.6667ZM4.19667 10.4733C3.93533 10.2133 3.934 9.792 4.19333 9.53067C4.45333 9.26867 4.874 9.26733 5.13667 9.52667L6.758 11.136C7.01333 11.3927 7.45067 11.3907 7.702 11.138L10.8793 8.17933C11.148 7.92867 11.5713 7.94333 11.8213 8.21267C12.0727 8.482 12.0573 8.904 11.788 9.15467L8.628 12.0973C8.26733 12.4587 7.76533 12.6667 7.23067 12.6667C6.696 12.6667 6.194 12.4587 5.816 12.0807L4.19667 10.4733Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7156_71587",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgBox;
